<template>
  <router-view/>
</template>

<script>
import store from './store'
import axios from 'axios'
import { FilterMatchMode } from 'primevue/api'

export default {
  name: 'App',

  mounted () {
    // store.commit('setSelectedCategory', 'j7Cq_ZJe_GkT')

    window.addEventListener('message', (event) => {
      if (event.data.initialJobId) {
        // console.log('initialJobId', event.data.initialJobId)

        this.$router.push({ name: 'jobView', params: { id: event.data.initialJobId } })
      }

      if (event.data.initialCategory) {
        // console.log('VUE: category', event.data.initialCategory)

        axios.get('https://app2.gotland.se/jobblista/proxy2.php?path=taxonomies')
          .then(resp => {
            const categories = resp.data

            // console.log('VUE categories from API:')
            // console.log(categories)

            if ((categories.find(category => category.name === event.data.initialCategory))?.id !== undefined) {
              // console.log('VUE: found matching category', (categories.find(category => category.name === event.data.initialCategory))?.id)

              store.commit('setSelectedCategory', (categories.find(category => category.name === event.data.initialCategory))?.id)
            } else {
              // console.log('VUE: did NOT find matching category')

              store.commit('setSelectedCategory', 'error')
            }
          })
      }

      if (event.data.initialFilterValue) {
        // console.log('VUE: initialFilterValue', event.data.initialFilterValue)

        store.commit('setFilters', {
          global: {
            value: event.data.initialFilterValue,
            matchMode: FilterMatchMode.CONTAINS
          }
        })
      }
    }, false)
  }
}
</script>

<style lang="scss">
/* open-sans-regular - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  src: url('@/assets/fonts/open-sans-v29-latin-regular.eot'); /* IE9 Compat Modes */
  src: local(''),
       url('@/assets/fonts/open-sans-v29-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('@/assets/fonts/open-sans-v29-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('@/assets/fonts/open-sans-v29-latin-regular.woff') format('woff'), /* Modern Browsers */
       url('@/assets/fonts/open-sans-v29-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('@/assets/fonts/open-sans-v29-latin-regular.svg#OpenSans') format('svg'); /* Legacy iOS */
}
/* open-sans-600 - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  src: url('@/assets/fonts/open-sans-v29-latin-600.eot'); /* IE9 Compat Modes */
  src: local(''),
       url('@/assets/fonts/open-sans-v29-latin-600.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('@/assets/fonts/open-sans-v29-latin-600.woff2') format('woff2'), /* Super Modern Browsers */
       url('@/assets/fonts/open-sans-v29-latin-600.woff') format('woff'), /* Modern Browsers */
       url('@/assets/fonts/open-sans-v29-latin-600.ttf') format('truetype'), /* Safari, Android, iOS */
       url('@/assets/fonts/open-sans-v29-latin-600.svg#OpenSans') format('svg'); /* Legacy iOS */
}
/* open-sans-700 - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  src: url('@/assets/fonts/open-sans-v29-latin-700.eot'); /* IE9 Compat Modes */
  src: local(''),
       url('@/assets/fonts/open-sans-v29-latin-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('@/assets/fonts/open-sans-v29-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
       url('@/assets/fonts/open-sans-v29-latin-700.woff') format('woff'), /* Modern Browsers */
       url('@/assets/fonts/open-sans-v29-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
       url('@/assets/fonts/open-sans-v29-latin-700.svg#OpenSans') format('svg'); /* Legacy iOS */
}
/* open-sans-italic - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 400;
  src: url('@/assets/fonts/open-sans-v29-latin-italic.eot'); /* IE9 Compat Modes */
  src: local(''),
       url('@/assets/fonts/open-sans-v29-latin-italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('@/assets/fonts/open-sans-v29-latin-italic.woff2') format('woff2'), /* Super Modern Browsers */
       url('@/assets/fonts/open-sans-v29-latin-italic.woff') format('woff'), /* Modern Browsers */
       url('@/assets/fonts/open-sans-v29-latin-italic.ttf') format('truetype'), /* Safari, Android, iOS */
       url('@/assets/fonts/open-sans-v29-latin-italic.svg#OpenSans') format('svg'); /* Legacy iOS */
}
/* open-sans-600italic - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 600;
  src: url('@/assets/fonts/open-sans-v29-latin-600italic.eot'); /* IE9 Compat Modes */
  src: local(''),
       url('@/assets/fonts/open-sans-v29-latin-600italic.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('@/assets/fonts/open-sans-v29-latin-600italic.woff2') format('woff2'), /* Super Modern Browsers */
       url('@/assets/fonts/open-sans-v29-latin-600italic.woff') format('woff'), /* Modern Browsers */
       url('@/assets/fonts/open-sans-v29-latin-600italic.ttf') format('truetype'), /* Safari, Android, iOS */
       url('@/assets/fonts/open-sans-v29-latin-600italic.svg#OpenSans') format('svg'); /* Legacy iOS */
}

/* MuseoSlab 700 */
@font-face {
  font-display: swap;
  font-family: "MuseoSlab";
  font-style: normal;
  font-weight: 700;
  src: url('@/assets/fonts/MuseoSlab-700.woff2') format('woff2');
}

/* MuseoSlab 500 */
@font-face {
  font-display: swap;
  font-family: "MuseoSlab";
  font-style: normal;
  font-weight: 500;
  src: url('@/assets/fonts/MuseoSlab-500.woff2') format('woff2');
}

* {
  font-family: 'Open sans', Tahoma, Arial, Verdana, sans-serif;
  font-size: 1rem;
}

body {
  line-height: 1.3em;
  font-weight: 400;
  color: #444648 !important;
}

h1, h2, h3, h4, h5, h6, .museo {
  font-family: MuseoSlab, sans-serif !important;
}

h2 { font-size: 26px !important; font-weight: 700 !important; }
h3 { font-size: 22px !important; font-weight: 700 !important; }

// .container {
//   max-width: 1000px;
//   margin: 0 auto;
//   margin-top: 50px;
// }

/* Bootstrap overrides */
.form-label {
  font-weight: bold;
}

.form-select {
  max-width: 300px;
}

.form-check-input:checked {
  background-color: #007864 !important;
  border-color: #007864 !important;
}

a:not(.btn) {
  color: #444648 !important;
  // text-decoration: none !important;
}

a:not(.btn):hover {
  text-decoration: underline !important;
}

a.action-link {
  background-color: unset;
  color: #444648;
  padding: 0;
  font-size: 1rem;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  display: flex !important;
  align-items: center !important;
}

a.action-link span {
  font-size: .8125rem;
  font-weight: 700;
  min-width: 0 !important;
}

a.action-link span.text {
  padding: 0 5px 0 5px;
  width: auto;
}

a.action-link span img {
  height: 1.7rem;
  fill: #444648;
  margin-left: -7px;
}

a.sol-btn {
  background-color: #007864;
  border-radius: 25px;
  color: #fff !important;
  display: inline-flex;
  line-height: 1.2;
  padding: 15px 25px;
  transition: background-color 0.2s ease;
}

a.sol-btn:hover {
  background-color: #016a5b;
}

/* Primevue overrides */
.p-datatable .p-datatable-header {
  font-weight: normal !important;
}

.p-datatable .p-sortable-column .p-column-title {
  font-family: MuseoSlab, sans-serif !important;
}

.p-datatable .p-sortable-column {
  background: #007864 !important;
  color: #fff !important;
}

.p-datatable .p-sortable-column.p-highlight {
  background: #005a4b !important;
  color: #fff !important;
}

.p-datatable .p-sortable-column.p-highlight, .p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon,
.p-datatable .p-sortable-column .p-sortable-column-icon {
  color: #fff !important;
}

.p-datatable .p-datatable-tbody > tr > td {
  border-width: 0 0 1px 0 !important;
}

.p-datatable .p-datatable-tbody > tr > td > .p-column-title {
  margin-right: 1.5rem;
}

@media screen and (max-width: 960px) {
  .p-datatable .p-datatable-tbody > tr > td > span:not(.p-column-title) {
    text-align: right;
  }
}

.p-datatable.p-datatable-sm .p-datatable-thead > tr > th {
  padding: 0.8rem 0.5rem !important;
}

.p-datatable .p-datatable-tbody > tr > td, .p-datatable .p-datatable-thead > tr > th {
  border: none !important;
}

.p-datatable .p-datatable-thead > tr > th:first-child { border-top-left-radius: 10px; }
.p-datatable .p-datatable-thead > tr > th:last-child { border-top-right-radius: 10px; }
.p-datatable .p-datatable-tbody > tr:last-child > td:first-child { border-bottom-left-radius: 10px; }
.p-datatable .p-datatable-tbody > tr:last-child > td:last-child { border-bottom-right-radius: 10px; }

.p-dropdown {
  width: 300px;
}

.p-datatable-table thead tr th {
  white-space: nowrap;
}

.font-bold {
  font-weight: bold;
}

.btn-rg {
  color: #fff !important;
  background-color: #c20e1a !important;
  border-color: #c20e1a !important;
}

dl.facts-list dt, dl.facts-list dd {
  display: inline;
}

dl.facts-list dt::after {
  content: ":";
}

dl.facts-list dd {
  margin-left: 10px;
}

.mw-300 {
  max-width: 300px;
}
</style>
